import React, { useState, useEffect } from 'react';

const Step2Age = ({ onNext, currentData }) => {
  const [selected, setSelected] = useState(currentData?.age || null);

  useEffect(() => {
    // Track Meta Pixel PageView
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, []);

  const options = [
    { value: 18, label: '18', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page2-18.webp' },
    { value: 21, label: '19-21', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page2-19-21.webp' },
    { value: 25, label: '22-25', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page2-22-25.webp' },
    { value: 30, label: '25+', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page2-25+.webp' }
  ];

  const handleSelect = (value) => {
    setSelected(value);
    setTimeout(() => {
      onNext({ age: value });
    }, 500);
  };

  return (
    <div className="step step-selection">
      <h2 className="step-title">How old would you like your AI Girlfriend to be?</h2>
      <div className="options-grid grid-2x2">
        {options.map(option => (
          <div
            key={option.value}
            className={`option-card ${selected === option.value ? 'selected' : ''}`}
            onClick={() => handleSelect(option.value)}
          >
            <img src={option.image} alt={option.label} className="option-image" />
            <div className="option-label">{option.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Step2Age;